import { Button, Result } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect } from "react";

import meta from "../../utils/meta";
import { useDispatch } from "react-redux";
import { logout } from "../../modules/session";
import { useHistory } from "react-router-dom";

function AgentExperience() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { workerOpenShiftsLink, workerWebApp } = meta();

  useEffect(() => {
    dispatch(logout());
    history.replace("/enter");
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Result
      status="404"
      title="Mobile App"
      subTitle={
        <div>
          {
            "Clipboard Health Mobile App becomes the required method for requesting and picking up shifts. Having trouble downloading the app? Use: "
          }
          <a href={workerWebApp}>{workerWebApp}</a>
        </div>
      }
      extra={
        <Button type="primary" href={workerOpenShiftsLink}>
          Open App
        </Button>
      }
    />
  );
}

export { AgentExperience };
